const configureTrackJs = (userId: string | null | undefined) => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
  if (window.trackJs && userId) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
    window.trackJs.configure({
      userId,
    });
  }
};

export default configureTrackJs;
